import {
  FETCH_SCAN_AVATAR,
  FETCH_SCAN_AVATAR_SUCCESS,
  FETCH_SCAN_AVATAR_FAILURE,
  RESET_SCAN_AVATAR,
} from './types'
import action from './middleware'

/**
 * Fetches scan avatar data from the API
 * @param {string} packageId - The scan package ID
 * @returns {function} Redux thunk action
 *
 * API Response shape:
 * {
 *   packageId: string,
 *   prismScanId: string,
 *   objAsset: {
 *     format: "obj",
 *     modelUrl: string | null,
 *     textureUrl: string | null
 *   }
 * }
 */
export const fetchScanAvatar = (packageId) => (dispatch) =>
  action(
    {
      endpoint: `/scans/${packageId}/snap`,
      method: 'GET',
      actionTypes: {
        requestType: FETCH_SCAN_AVATAR,
        successType: FETCH_SCAN_AVATAR_SUCCESS,
        failureType: FETCH_SCAN_AVATAR_FAILURE,
      },
    },
    dispatch
  )

/**
 * Resets the scan avatar state in Redux store
 * @returns {object} Redux action
 */
export const resetScanAvatar = () => ({
  type: RESET_SCAN_AVATAR,
})
